import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import Template from './Template'
import T from '../translate/T'


import ProtectedRoute from '../v2SPRINTA/organisms/ProtectedRoute'

import CreateEvent from './pages/CreateEvent'
import EventOk from './pages/EventOk'
import CreateExperience from './pages/CreateExperience';
import CreateGym from './pages/CreateGym';
import ExperienceOk from './pages/ExperienceOk';
import GymOk from './pages/GymOk';
import ExperienceContinue from './pages/ExperienceContinue';
import ExperienceFinished from './pages/ExperienceFinished';
import GymFinished from './pages/GymFinished';
import Dev from './pages/Dev';
import CreateProduct from './pages/CreateProduct';

class App extends Component {
  componentWillMount() {
    T.handleUpdate( () => this.forceUpdate() )
  }

  render() {
    return (
      <Template>
        <Switch>
          <Route exact path="/" component={Dev} />
          <Route exact path="/create/event" component={CreateEvent} />
          <Route exact path="/create/event/done/:token" component={EventOk} />
          <Route exact path="/create/experience" component={CreateExperience} />
          <Route exact path="/create/gym" component={CreateGym} />
          <Route exact path="/create/experience/done/:token" component={ExperienceOk} />
          <Route exact path="/create/gym/done/:token" component={GymOk} />
          <Route exact path="/create/experience/continue/:token" component={ProtectedRoute(ExperienceContinue)} />
          <Route exact path="/create/experience/finished/:token" component={ProtectedRoute(ExperienceFinished)} />
          <Route exact path="/create/gym/finished/:token" component={ProtectedRoute(GymFinished)} />
          <Route exact path="/create/product" component={ProtectedRoute(CreateProduct)} />
        </Switch>
      </Template>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/index.js